import { Link } from "react-router-dom";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_naljuri-riverside/artifacts/3iyn6v9a_naljuri%20logo.jpeg";

export default function Logo({ size = 36, light = false, withText = true, linkTo = "/", testid = "site-logo" }) {
  const content = (
    <span className="flex items-center gap-3" data-testid={testid}>
      <span
        className={`relative inline-flex shrink-0 rounded-full overflow-hidden ring-1 ${light ? 'ring-gold-400/50' : 'ring-gold-600/40'} bg-white`}
        style={{ width: size, height: size }}
      >
        <img src={LOGO_URL} alt="Naljuri Inn logo" className="w-full h-full object-cover" />
      </span>
      {withText && (
        <span className="leading-none">
          <span className={`block font-display tracking-tight ${light ? 'text-cream-100' : 'text-forest-700'}`}
                style={{ fontSize: Math.round(size * 0.6) }}>
            Naljuri
          </span>
          <span className={`block text-[9px] tracking-widest2 uppercase mt-0.5 ${light ? 'text-gold-400' : 'text-gold-600'}`}>
            Inn · Sylhet
          </span>
        </span>
      )}
    </span>
  );

  if (linkTo) return <Link to={linkTo}>{content}</Link>;
  return content;
}
